// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_box":"col_box-1vLdYV_x","col_navlist":"col_navlist-1Nz63kgd","pa":"pa-1sA-Q8Si"};